module.exports = __webpack_public_path__ + "img/file-question-02.df3c89f8.svg";